<template>
  <v-row no-gutters>
    <v-spacer></v-spacer>
    <v-col cols="4" class="text-right">
      <v-btn v-if="needsCancelButton" @click="ignore()">
        {{ ignoreButtonName }}
      </v-btn>
      <v-btn color="success" class="ml-4" @click="approve()">
        {{ successButtonName }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import request from "../../request";
export default {
  props: [
    "needsCancelButton",
    "ignoreButtonName",
    "successButtonName",
    "validation",
  ],
  methods: {
    ignore() {
      request.post(
        "/api/optiek-jo/ignore-validation-error?validationErrorId=" +
          this.validation.Id,
        null,
        (res) => {
          if (res.success) {
            this.$emit("deleteOutArray", this.validation.Id);
          }
        }
      );
    },
    approve() {
      request.post(
        "/api/optiek-jo/approve-validation-error?validationErrorId=" +
          this.validation.Id,
        null,
        (res) => {
          if (res.success) {
            this.$emit("deleteOutArray", this.validation.Id);
          }
        }
      );
    },
  },
};
</script>

<style>
</style>